<template>
  <common-card>
    <v-row>
      <v-col>
        <v-row style="padding: 15px 20px 0px 20px">
          <v-col cols="12" md="6">
            <h1>Administrador de recordatorios</h1>
          </v-col>

          <v-col cols="12" md="6" style="text-align: end">
            <v-btn
              class="common-botton"
              dark
              :loading="loading"
              @click="openModal(true)"
            >
              <v-icon class="mr-2">mdi-plus</v-icon>
              <span>Crear</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Filtros -->
    <v-expansion-panels
      elevation="0"
      style="padding: 30px; border-radius: 20px"
    >
      <v-expansion-panel>
        <v-expansion-panel-header style="padding: 35px">
          <h3 style="color: #42352e">Búsqueda detallada</h3>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filtros.producto"
                label="Producto"
                :items="productosInbound"
                item-text="producto"
                item-value="producto"
                outlined
                dense
                color="primary"
                background-color="white"
                clearable
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filtros.empresaFiltro"
                label="Empresa"
                :items="todasLasEmpresas"
                outlined
                dense
                color="primary"
                background-color="white"
                clearable
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-autocomplete
                v-model="filtros.status"
                label="Estatus"
                :items="statusItems"
                item-text="text"
                item-value="value"
                outlined
                dense
                color="primary"
                background-color="white"
                clearable
              />
            </v-col>

            <v-col cols="12" md="3">
              <v-text-field
                v-model="filtros.nombre"
                label="Nombre recordatorio"
                outlined
                dense
                color="primary"
                background-color="white"
              />
            </v-col>

            <v-col cols="12" style="text-align: end">
              <v-btn
                color="primary"
                style="border-radius: 15px; margin-right: 10px"
                outlined
                dark
                :loading="loading"
                @click="clearFilters"
              >
                <span>Limpiar</span>
              </v-btn>

              <v-btn
                class="common-botton"
                dark
                :loading="loading"
                @click="onFiltrar"
              >
                <span>Filtrar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div style="padding: 0px 40px 0px 40px">
      <hr />
    </div>

    <!-- Tabla -->
    <v-row>
      <v-col cols="12" class="mb-10" style="padding: 40px">
        <v-data-table
          :headers="headers"
          :items="recordatorios"
          class="elevation-0"
          :loading="loading"
          loading-text="Cargando..."
          no-data-text="Para ver elementos, primero realiza una búsqueda"
          :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50] }"
          :server-items-length="total"
          @update:page="page = $event"
          @update:items-per-page="size = $event"
        >
          <template v-slot:top>
            <v-row style="padding: 15px">
              <v-col cols="8">
                <h2>Resultados de la búsqueda</h2>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.empresas="{ item }">
            <template v-if="item.empresas && item.empresas.length">
              <v-chip
                v-for="e in item.empresas.slice(0, 2)"
                :key="e.id"
                small
                class="mr-1"
              >
                {{ e.empresa }}
              </v-chip>
              <span
                v-if="item.empresas.length > 2"
                class="grey--text text-caption"
              >
                +{{ item.empresas.length - 2 }}
              </span>
            </template>
          </template>

          <template v-slot:item.status="{ item }">
            <span>{{ mapStatus(item.status) }}</span>
          </template>

          <template v-slot:item.ver="{ item }">
            <v-btn small icon @click="openModal(false, item)">
              <v-icon small>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Modal -->
    <RecordatoriosModal
      v-if="dialog"
      v-show="dialog"
      :dialog="dialog"
      :isNew="isNew"
      :selected="selected"
      @success="successModal"
      @closeModal="dialog = false"
    />
  </common-card>
</template>

<script>
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import { getRecordatorioList } from "@/services/recordatorios/recordatorio.service.js";
import { getEmpresasInbound } from "@/services/empresasInbound/EmpresasInbound.js";

export default {
  components: {
    CommonCard,
    RecordatoriosModal: () =>
      import("@/components/commonComponents/dialogs/RecordatoriosModal.vue"),
  },

  data() {
    return {
      loading: false,
      hasSearched: false,
      headers: [
        { text: "ID", value: "id" },
        { text: "Producto", value: "producto" },
        { text: "Empresas", value: "empresas" },
        { text: "Nombre", value: "nombre" },
        { text: "Estatus", value: "status" },
        { text: "Plantilla", value: "templateRecInfoName" },
        { text: "Ver", value: "ver", sortable: false },
      ],

      statusItems: [
        { text: "Activo", value: 1 },
        { text: "Inactivo", value: 2 },
        { text: "Todos", value: null },
      ],

      filtros: {
        ramo: "",
        producto: null,
        // empresa: null,
        empresaFiltro: null,
        status: null,
        nombre: "",
      },
      empresasInboundRaw: [],
      ramosInbound: [],
      productosInbound: [],
      empresasInbound: [],
      todasLasEmpresas: [],

      recordatorios: [],
      page: 0,
      size: 10,
      total: 0,

      dialog: false,
      isNew: true,
      selected: null,
    };
  },

  watch: {
    page(v) {
      if (!this.hasSearched) return;
      if (v || v === 0) this.getRecordatorios();
    },
    size(v) {
      if (!this.hasSearched) return;
      if (v > 0) this.size = v;
      else this.size = this.total;
      this.getRecordatorios();
    },

    "filtros.producto"(val) {
      this.filtros.empresa = null;

      if (!val) {
        this.empresasInbound = [];
        return;
      }

      const productos = this.empresasInboundRaw.map((x) => x.producto);
      this.productosInbound = [...new Set(productos)]
        .filter(Boolean)
        .map((p) => ({ producto: p }));

      const empresas = this.empresasInboundRaw
        .filter((x) => x.producto === val)
        .map((x) => x.empresa);

      this.empresasInbound = [...new Set(empresas)]
        .filter(Boolean)
        .sort()
        .map((e) => ({ empresa: e }));
    },
  },

  methods: {
    mapStatus(v) {
      if (v === 1) return "Activo";
      if (v === 2) return "Inactivo";
      return v ?? "-";
    },

    async onFiltrar() {
      this.hasSearched = true;
      await this.getRecordatorios(true);
    },

    async loadEmpresasInbound() {
      try {
        const resp = await getEmpresasInbound();

        this.empresasInboundRaw = resp?.data?.empresas ?? [];

        const ramos = this.empresasInboundRaw.map((x) => x.ramo);
        this.ramosInbound = [...new Set(ramos)].filter(Boolean).sort();

        const empresas = this.empresasInboundRaw.map((x) => x.empresa);
        this.todasLasEmpresas = [...new Set(empresas)].filter(Boolean).sort();

        const productos = this.empresasInboundRaw.map((x) => x.producto);
        this.productosInbound = [...new Set(productos)]
          .filter(Boolean)
          .sort()
          .map((p) => ({ producto: p }));
      } catch (e) {
        this.$toast?.error?.(
          e?.message || "No se pudo cargar catálogo de empresas",
        );
      }
    },

    async getRecordatorios(restartPagination = false) {
      this.loading = true;

      // Armado de filtros (solo los que tengan valor)
      const finalFilters = {};
      Object.keys(this.filtros).forEach((k) => {
        const val = this.filtros[k];
        if (val !== "" && val !== null && val !== undefined)
          finalFilters[k] = val;
      });

      // Body según tu ejemplo
      const body = {
        producto: finalFilters.producto,
        //empresa: finalFilters.empresa,

        page: !restartPagination ? this.page : 0,
        size: finalFilters.empresaFiltro
          ? 1000
          : !restartPagination
          ? this.size
          : 10,
        order: "asc",
      };

      if (finalFilters.nombre && finalFilters.nombre.trim()) {
        body["Like_nombre"] = finalFilters.nombre.trim();
      }

      if (finalFilters.status === 1 || finalFilters.status === 2) {
        body.status = finalFilters.status;
      }

      try {
        const response = await getRecordatorioList(body);

        // Si viene directo como array:
        if (Array.isArray(response)) {
          this.recordatorios = response;
          this.total = response.length; // o deja 0 si realmente paginan pero no mandan count
        } else {
          // fallback por si luego lo envuelven
          const list =
            response?.data?.recordatorios ||
            response?.recordatorios ||
            response?.data ||
            response?.items ||
            [];

          this.recordatorios = Array.isArray(list) ? list : [];
          this.total =
            response?.data?.count ||
            response?.count ||
            response?.numRegisters ||
            response?.total ||
            this.recordatorios.length;
        }
        if (this.filtros.empresaFiltro) {
          this.recordatorios = this.recordatorios.filter((r) =>
            r.empresas?.some((e) => e.empresa === this.filtros.empresaFiltro),
          );
          this.total = this.recordatorios.length;
        }
      } catch (e) {
        this.$toast?.error?.("No se pudo obtener la lista de recordatorios");
      } finally {
        this.loading = false;
      }
    },

    clearFilters() {
      Object.assign(this.filtros, {
        ramo: "",
        producto: null,
        // empresa: null,
        empresaFiltro: null,
        status: null,
        nombre: "",
      });

      this.productosInbound = [];
      // this.empresasInbound = [];
      this.hasSearched = false;
      this.recordatorios = [];
      this.total = 0;
    },

    openModal(isNew = false, item = null) {
      this.isNew = isNew;
      this.selected = isNew ? null : item;
      this.dialog = true;
    },

    successModal() {
      this.dialog = false;
      this.getRecordatorios(true);
    },
  },

  mounted() {
    //this.getRecordatorios(true);
    this.loadEmpresasInbound();
  },
};
</script>

<style scoped>
.theme--light.v-data-table {
  background-color: #f2fafc;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 20px;
}

.v-expansion-panel {
  border-radius: 20px;
}

.v-expansion-panels {
  z-index: auto !important;
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(
    .v-expansion-panels--tile
  )
  > .v-expansion-panel--active {
  border-radius: 20px !important;
}

.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #f6f5f9;
  color: rgba(0, 0, 0, 0.87);
}
</style>
